import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=12ec246b&scoped=true"
import script from "./Header3.vue?vue&type=script&lang=js"
export * from "./Header3.vue?vue&type=script&lang=js"
import style0 from "./Header3.vue?vue&type=style&index=0&id=12ec246b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec246b",
  null
  
)

export default component.exports